import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import screenfull from "screenfull";
import { Col, Image, Modal, Row } from "react-bootstrap";
import { SingleChoiceQuestion } from "./SingleChoiceQuestion";
import { SingleLineQuestion } from "./SingleLineQuestion";
import { MultipleChoiceQuestion } from "./MultipleChoiceQuestion";
import { MultipleLineQuestion } from "./MultipleLineQuestion";
import { QUIZ_TYPE } from "@constants";
import { isCorrectAnswer, replaceErrorImage } from "@helpers";
import styles from "./styles/Question.module.css";

const Question = (props) => {
  const {
    title,
    image,
    options,
    type,
    score,
    userAnswer = [],
    onChangeAnswer,
    correctAnswer,
    showAnswer,
    textAnswer,
  } = props;

  // state
  const [showImg, setShowImg] = useState(false);

  // variables
  const isCorrect = useMemo(() => {
    return showAnswer ? isCorrectAnswer(props) : false;
  }, [showAnswer]);

  // logics before hooks

  // hooks

  // logics

  // UI partials
  const questionImage = image && (
    <div className={styles.imgContainer}>
      <Image
        src={image}
        alt="question image"
        onClick={() => {
          if (screenfull.isFullscreen) {
            screenfull.exit();
          }
          setShowImg(true);
        }}
        onError={replaceErrorImage}
      />
      <Modal
        show={showImg}
        onHide={() => setShowImg(false)}
        dialogClassName={styles.modalImg}
        contentClassName="border-0"
      >
        <Image src={image} alt="question image" onError={replaceErrorImage} />
      </Modal>
    </div>
  );

  const iconResult = isCorrect ? `${score}/` : "0/";

  // effects

  // render
  return (
    <div className={clsx(styles.questionContainer, "border rounded")}>
      <div>
        <p className={styles.title}>{title}</p>
        <p
          className={clsx(
            styles.score,
            showAnswer && isCorrect && styles.correctAnswer
          )}
        >
          {showAnswer && iconResult}
          {score && <span>{score} points</span>}
        </p>
      </div>
      <Row className="g-2">
        <Col xs={12} md={image ? 8 : 12}>
          {type === QUIZ_TYPE.SINGLE_CHOICE && (
            <SingleChoiceQuestion
              options={options}
              userAnswer={userAnswer}
              onChange={onChangeAnswer}
              showAnswer={showAnswer}
              isCorrect={isCorrect}
              correctAnswer={correctAnswer}
            />
          )}
          {type === QUIZ_TYPE.MULTI_CHOICE && (
            <MultipleChoiceQuestion
              options={options}
              userAnswer={userAnswer}
              onChange={onChangeAnswer}
              showAnswer={showAnswer}
              isCorrect={isCorrect}
              correctAnswer={correctAnswer}
            />
          )}
          {type === QUIZ_TYPE.SINGLE_LINE && (
            <SingleLineQuestion
              userAnswer={userAnswer}
              onChange={onChangeAnswer}
              showAnswer={showAnswer}
              isCorrect={isCorrect}
              correctAnswer={textAnswer}
            />
          )}
          {type === QUIZ_TYPE.MULTI_LINE && (
            <MultipleLineQuestion
              userAnswer={userAnswer}
              onChange={onChangeAnswer}
              showAnswer={showAnswer}
              isCorrect={isCorrect}
              correctAnswer={textAnswer}
            />
          )}
        </Col>
        <Col xs={12} md={4}>
          {questionImage}
        </Col>
      </Row>
    </div>
  );
};

/* required: display name */
Question.displayName = "Question";

/* required: props types */
Question.propTypes = {
  title: PropTypes.string,
  image: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  type: PropTypes.number,
  userAnswer: PropTypes.arrayOf(PropTypes.string),
  onChangeAnswer: PropTypes.func,
  correctAnswer: PropTypes.arrayOf(PropTypes.string),
  isCorrect: PropTypes.bool,
  showAnswer: PropTypes.bool,
};

/* required: default props */
Question.defaultProps = {
  title: "",
  options: [],
  type: QUIZ_TYPE.MULTI_LINE,
  userAnswer: [],
  onChangeAnswer: () => {},
  correctAnswer: [],
  showAnswer: false,
};

export { Question };
